<script lang="ts">
    import { onMount, onDestroy, tick } from "svelte";
    import { cn } from "../cn";
    import { portal } from "../portal";

    export let align: "start" | "end" = "end";
    let className = "";
    export { className as class };

    let open = false;
    let triggerEl: HTMLSpanElement;
    let menuEl: HTMLDivElement;
    let menuStyle = "";

    async function toggle() {
        open = !open;
        if (open) {
            await tick();
            position();
        }
    }

    function position() {
        if (!triggerEl) return;
        const rect = triggerEl.getBoundingClientRect();
        const top = rect.bottom + 4;
        if (align === "end") {
            const right = window.innerWidth - rect.right;
            menuStyle = `position:fixed; top:${top}px; right:${right}px;`;
        } else {
            menuStyle = `position:fixed; top:${top}px; left:${rect.left}px;`;
        }
    }

    function closeIfOutside(e: MouseEvent) {
        const t = e.target as Node;
        if (
            (triggerEl && triggerEl.contains(t)) ||
            (menuEl && menuEl.contains(t))
        )
            return;
        open = false;
    }
    function handleEsc(e: KeyboardEvent) {
        if (e.key === "Escape") open = false;
    }
    function reposition() {
        if (open) position();
    }

    onMount(() => {
        document.addEventListener("mousedown", closeIfOutside);
        document.addEventListener("keydown", handleEsc);
        window.addEventListener("scroll", reposition, true);
        window.addEventListener("resize", reposition);
    });
    onDestroy(() => {
        document.removeEventListener("mousedown", closeIfOutside);
        document.removeEventListener("keydown", handleEsc);
        window.removeEventListener("scroll", reposition, true);
        window.removeEventListener("resize", reposition);
    });
</script>

<span
    class="relative inline-block"
    bind:this={triggerEl}
    on:click={toggle}
>
    <slot name="trigger" />
</span>

{#if open}
    <div
        use:portal
        bind:this={menuEl}
        style={menuStyle}
        class={cn(
            "z-[200] min-w-[10rem] rounded-md border border-[var(--border)] bg-[var(--popover)] text-[var(--popover-foreground)] shadow-xl shadow-black/30 py-1 animate-in fade-in-0 zoom-in-95 duration-100",
            className,
        )}
        on:click={() => (open = false)}
        role="menu"
    >
        <slot />
    </div>
{/if}
